import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FicheIntervention } from 'app/models/ficheIntervention.model';
import { NiveauService } from 'app/services/niveau.service';
import { Niveau } from 'app/models/niveau.model';
import { MatDialog } from '@angular/material/dialog';
import { EtageService } from 'app/services/etage.service';
import { Etage } from 'app/models/etage.model';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UserService } from 'app/core/user/user.service';
import { CroquisService } from 'app/services/croquis.service';
import html2canvas from 'html2canvas';
import { ToastrService } from 'ngx-toastr';
import {et} from 'date-fns/locale';

@Component({
  selector: 'app-etage-v2',
  templateUrl: './etage-v2.component.html',
  styleUrls: ['./etage-v2.component.scss']
})
export class EtageV2Component implements OnInit {
  @Input() currentFicheIntervention: FicheIntervention = new FicheIntervention();
  @Input() idDossierIntervention: number;

  ficheAjoutNiveau: FormGroup;
  niveaux: Niveau[] = [];
  niveauxRestant: Niveau[] = [];
  etages: Etage[] = [];

  isLoaded = false;

  constructor(private niveauService: NiveauService, private etageService: EtageService, private dialog: MatDialog, private fuseConfirmationService: FuseConfirmationService, private _userService: UserService, private croquisService: CroquisService, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.initForm();
    this.getEtages();
  }

  initForm() {
    this.ficheAjoutNiveau = new FormGroup({
      champ_niveau: new FormControl(null, [Validators.required])
    });
  }

  getNiveaux() {
    this.niveauService.getNiveaux().subscribe((niveaux) => {
      this.niveaux = niveaux;

      this.isLoaded = true;
      this.filtreNiveauAfficher();
    });
  }

  getEtages() {
    this.etageService.getEtages(this.idDossierIntervention).subscribe((etages) => {
      this.etages = etages;

      this.getNiveaux();
    });
  }

  ajouterNiveau() {
    // event.stopPropagation();
    // const dialogRef = this.dialog.open(ModalFormNiveauComponent, {
    //   width: '35%',
    // });
    //
    // dialogRef.afterClosed().subscribe(result => {
    //   if (result != undefined) {
    //     this.getNiveaux();
    //     this.ficheAjoutNiveau.patchValue({
    //       champ_niveau: result.id != null ? +result.id : null
    //     });
    //   }
    // });
  }

  ajouterEtage(){
    if(this.ficheAjoutNiveau.get('champ_niveau').value == null){
      this.toastr.warning('Veuillez choisir un niveau à ajouter');
      return;
    }

    let etage = this.etages.find(e => e.nom_niveau == this.ficheAjoutNiveau.get('champ_niveau').value);

    if(!etage){
        etage = new Etage({
            nom_niveau:this.ficheAjoutNiveau.get('champ_niveau').value,
        });
    }

    etage.dossier_intervention_id = this.idDossierIntervention;

    this.etageService.store(etage).subscribe(() => {
      this.getEtages();
    });
  }

  filtreNiveauAfficher(){
    const listEtageAjouter = this.etages.map(etage => etage.niveau_id);
    this.niveauxRestant = this.niveaux.filter(niveau => !listEtageAjouter.includes(niveau.id));
  }

  delete(id: number) {
    const confirmation = this.fuseConfirmationService.open({
      title: 'Suppression d\'un étage',
      message: 'Êtes-vous certain de vouloir supprimer cet étage et le croquis attaché',
      actions: {
        confirm: {
          label: 'Supprimer'
        }
      }
    });

    confirmation.afterClosed().subscribe((result) => {
      if (result === 'confirmed') {
        this.etageService.delete(id).subscribe(
          () => {
              this.getEtages();
          },
          (error) => {
            console.log(error);
            // this.showErrors(error);
          });
      }
    });
  }

  afficher_image(etage_id: number){
    this.croquisService.getSVGParEtage(etage_id).subscribe((svg) => {
      if(svg == ''){
        this.toastr.warning('Il n\'y a pas encore de croquis pour cet étage');
        return;
      }

      document.getElementById('croquis_image_svg_content').innerHTML = svg;
      const svgElement = document.getElementById('croquis_image_svg');

        // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
      html2canvas(svgElement).then(function(canvas) {
        const dataURL = canvas.toDataURL('image/png');
        const imgElement = document.createElement('img');
        imgElement.src = dataURL;

        document.getElementById('croquis_image_png').innerHTML = '';
        document.getElementById('croquis_image_png').appendChild(imgElement);

        // Pour télécharger
        const linkElement = document.createElement('a');
        linkElement.href = dataURL;
        linkElement.download = 'mon_plan.png';
        linkElement.click();

        document.getElementById('croquis_image_svg_content').innerHTML = '';
        document.getElementById('croquis_image_png').innerHTML = '';
      });
    });
  }

  getNomNiveau(niveau_id: number){
    const niveauAfficher = this.niveaux.find(niveau => niveau.id == niveau_id);
    return niveauAfficher?.niveau;
  }

  get isAdmin(): boolean {
    return this._userService.getCurrentUser().role_id == 1;
  }
}
